import React, { useEffect } from "react";
import {
  DocumentAgreement,
  // DocumentModal,
  Permissions,
} from "@hedgefund/shared";
import {
  getAllDocuments,
  uploadDocument,
  updateDocumentStatus,
} from "./actions";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "@public/ui-toolkit";

const DocumentDetail = ({ match }) => {
  const documentDetailState = useSelector((state) => state.documentDetail);
  const dispatch = useDispatch();

  const { allDocuments, loading, updatedDocType } = documentDetailState;

  let id = match.params.id;

  useEffect(() => {
    dispatch(getAllDocuments(id));
  }, [dispatch, id]);

  const onUploadDocuments = (values, typeId) => {
    dispatch(uploadDocument(values, typeId));
  };

  const onUpdateDocumentStatus = (values) => {
    dispatch(updateDocumentStatus(values));
  };

  return (
    <>
      <main className="main-doc">
        <div className="main-inner">
          <div className="container mt-5">
            {loading && updatedDocType === null ? (
              <Spinner className="text-center" />
            ) : (
              <div className="document-cloud rounded-large box-shadow bg-white p-xxl-5 p-md-4 p-3 mb-sm-5 mb-4 mt-5">
                <div className="text-center mb-5">
                  <h2 className="stylish-title text-blue">Document Cloud</h2>
                </div>
                  <>
                    <DocumentAgreement
                      allDocuments={allDocuments}
                      onUploadDocuments={onUploadDocuments}
                      fundInvestorId={id}
                      onUpdateDocumentStatus={onUpdateDocumentStatus}
                      // index={index}
                      loading={loading}
                      updatedDocType={updatedDocType}
                      Permissions={Permissions}
                    />
                  </>
                {/* <div className="row g-5">
                  {allDocuments?.map((doc, index) => {
                    return (
                     
                    );
                  })}
                </div> */}
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default DocumentDetail;
